module.exports = __webpack_public_path__ + "img/fw141.prt.afa59d46.jpg";